import React from 'react'
import { Outlet } from 'react-router-dom'

function MainClientTickets() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainClientTickets
